import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { CustomHttpInterceptor } from "providers/custom-http-interceptor/custom-http.interceptor";
import { AuthorizationHttpInterceptor } from "../../../app/authorization/AuthorizationHttpInterceptor";
import { AssessmentDataService } from "../../../providers/asmt-data-service/asmt-data-service";
import { TooltipModule } from "../../../tooltip/tooltip.module";
import { CommonComponentsModule } from "../../common/common-components.module";
import { ComponentsModule } from "../../components.module";
import { PrnCountModule } from "../../prn-count/prn-count.module";
import { ToolsModule } from "../../tools/tools.module";
import { CanvasModule } from "../canvas/canvas.module";
import { ConfigurableInputsModule } from "../inputs/configurable-inputs.module";
import { AddendumAttestationListCardComponent } from "./add-att-list-card/add-att-list-card";
import { AddendumNoteListCardComponent } from "./addendum-list-card/addendum-list-card";
import { AdditionalListCardComponent } from "./additional-list-card/additional-list-card";
import { CovidScreening } from "./covid-screening/covid-screening";
import { CreatinineViewCardComponent } from "./creatinine-view-card/creatinine-view-card";
import { DeclineCardComponent } from "./decline-card/decline-card";
import { DiagnosesCard } from "./diagnoses-card/diagnoses-card";
import { DynamicFormComponent } from "./dynamic-form/dynamic-form";
import { ExaminationCard } from "./examination-card/examination-card";
import { ExpandableListCardWithPreviousComponent } from "./expandable-list-card-with-previous/expandable-list-card-with-previous";
import { ExpandableListCardComponent } from "./expandable-list-card/expandable-list-card";
import { FormCardWithPreviousComponent } from "./form-card-with-previous/form-card-with-previous";
import { FormCardComponent } from "./form-card/form-card";
import { GridPropertiesDirective } from "./grid-properties/grid-properties";
import { HacExpandableListCard } from "./hac-expandable-list-card/hac-expandable-list-card";
import { HistoryListCardComponent } from "./history-list-card/history-list-card";
import { IntercardDataService } from "./intercard-data/intercard-data.service";
import { ListCardComponent } from "./list-card/list-card";
import { MarCardComponent } from "./mar-card/mar-card";
import { MmseCardComponent } from "./mmse-card/mmse-card";
import { NarrativeListCardComponent } from "./narrative-list-card/narrative-list-card";
import { NewExpandableListCard } from "./new-expandable-list-card/new-expandable-list-card";
import { NewWoundCanvasComponent } from "./new-wound-site-card/new-wound-canvas/new-wound-canvas";
import { NewWoundLocationComponent } from "./new-wound-site-card/new-wound-location/new-wound-location";
import { NewWoundNotesComponent } from "./new-wound-site-card/new-wound-notes/new-wound-notes";
import { NewWoundScoreComponent } from "./new-wound-site-card/new-wound-score/new-wound-score";
import { NewWoundSidebarComponent } from "./new-wound-site-card/new-wound-sidebar/new-wound-sidebar";
import { NewWoundSiteCardComponent } from "./new-wound-site-card/new-wound-site-card";
import { NewWoundSitePopoverPage } from "./new-wound-site-card/new-wound-site-popover/new-wound-site-popover";
import { NewWoundSiteTabsComponent } from "./new-wound-site-card/new-wound-site-tabs/new-wound-site-tabs";
import { NewWoundSummaryComponent } from "./new-wound-site-card/new-wound-summary/new-wound-summary";
import { OrderEntryOmCard } from "./order-entry-om/order-entry-om-card";
import { PainSiteCardSidebarComponent } from "./pain-site-card-sidebar/pain-site-card-sidebar";
import { PalliativeCardComponent } from "./palliative-card/palliative-card";
import { PatientHistoryCardComponent } from "./patient-history-card/patient-history-card";
import { QuestionsCardComponent } from "./questions-card/questions-card";
import { RecursiveGridComponent } from "./recursive-grid/recursive-grid";
import { ReviewSystemCard } from "./review-systems-card/review-systems-card";
import { TimeToTaskListCardComponent } from "./time-to-task-list-card/time-to-task-list-card";
import { VisitFrequencyListCard } from "./visit-frequency-list-card/visit-frequency-list-card";
import { VisitFrequencyListItem } from "./visit-frequency-list-item/visit-frequency-list-item";
import { WoundHistoryCardComponent } from "./wound-history-card/wound-history-card";
import { WoundSiteCardComponent } from "./wound-site-card/wound-site-card";
import { WoundSiteModalSidebarComponent } from "./wound-site-modal-sidebar/wound-site-modal-sidebar";
import { WoundSiteNotesComponent } from "./wound-site-notes/wound-site-notes";

@NgModule({
  declarations: [
    AddendumNoteListCardComponent,
    AddendumAttestationListCardComponent,
    DeclineCardComponent,
    DynamicFormComponent,
    ExpandableListCardComponent,
    ExpandableListCardWithPreviousComponent,
    FormCardComponent,
    GridPropertiesDirective,
    HistoryListCardComponent,
    ListCardComponent,
    MmseCardComponent,
    NarrativeListCardComponent,
    PainSiteCardSidebarComponent,
    QuestionsCardComponent,
    RecursiveGridComponent,
    TimeToTaskListCardComponent,
    WoundSiteCardComponent,
    WoundSiteModalSidebarComponent,
    WoundSiteNotesComponent,
    PalliativeCardComponent,
    VisitFrequencyListCard,
    OrderEntryOmCard,
    AdditionalListCardComponent,
    CreatinineViewCardComponent,
    MarCardComponent,
    VisitFrequencyListItem,
    NewWoundSiteCardComponent,
    NewWoundSiteTabsComponent,
    NewWoundLocationComponent,
    WoundHistoryCardComponent,
    NewWoundSidebarComponent,
    NewWoundScoreComponent,
    NewWoundNotesComponent,
    NewWoundSummaryComponent,
    NewWoundCanvasComponent,
    NewWoundSitePopoverPage,
    NewExpandableListCard,
    HacExpandableListCard,
    ReviewSystemCard,
    PatientHistoryCardComponent,
    DiagnosesCard,
    ExaminationCard,
    CovidScreening,
    FormCardWithPreviousComponent,
  ],
  imports: [
    CanvasModule,
    IonicModule,
    TooltipModule,
    TranslateModule.forChild(),
    ConfigurableInputsModule,
    CommonComponentsModule,
    ToolsModule,
    ComponentsModule,
    NgSelectModule,
    PrnCountModule,
  ],
  exports: [
    AddendumNoteListCardComponent,
    AddendumAttestationListCardComponent,
    DeclineCardComponent,
    DynamicFormComponent,
    ExpandableListCardComponent,
    ExpandableListCardWithPreviousComponent,
    FormCardComponent,
    GridPropertiesDirective,
    HistoryListCardComponent,
    ListCardComponent,
    MmseCardComponent,
    NarrativeListCardComponent,
    PainSiteCardSidebarComponent,
    QuestionsCardComponent,
    RecursiveGridComponent,
    TimeToTaskListCardComponent,
    WoundSiteCardComponent,
    WoundSiteModalSidebarComponent,
    WoundSiteNotesComponent,
    PalliativeCardComponent,
    VisitFrequencyListCard,
    OrderEntryOmCard,
    AdditionalListCardComponent,
    CreatinineViewCardComponent,
    MarCardComponent,
    VisitFrequencyListItem,
    NewWoundSiteCardComponent,
    NewWoundSiteTabsComponent,
    NewWoundLocationComponent,
    WoundHistoryCardComponent,
    NewWoundSidebarComponent,
    NewWoundScoreComponent,
    NewWoundNotesComponent,
    NewWoundSummaryComponent,
    NewWoundCanvasComponent,
    NewWoundSitePopoverPage,
    NewExpandableListCard,
    HacExpandableListCard,
    ReviewSystemCard,
    ComponentsModule,
    PatientHistoryCardComponent,
    DiagnosesCard,
    ExaminationCard,
    CovidScreening,
    FormCardWithPreviousComponent,
  ],
  providers: [
    IntercardDataService,
    AssessmentDataService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
  ],
})
export class ConfigurableCardsModule {}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/configurable-cards.module.ts